import { ACCESS } from '@src/configs/permission'
import lazyLoading from '@src/components/widgets/LazyLoading'

import { TRouteConfig } from '../routeConfig'

const List = lazyLoading(() => import('@src/pages/product-property/accessory'))
const Create = lazyLoading(() => import('@src/pages/product-property/accessory/create'))
const Detail = lazyLoading(() => import('@src/pages/product-property/accessory/detail'))

const accessoryRouter: TRouteConfig[] = [
  {
    path: '/accessory',
    Element: List,
    key: ACCESS.LIST_ACCESSORY,
  },
  {
    path: '/create-accessory',
    Element: Create,
    key: ACCESS.ADD_ACCESSORY,
  },
  {
    path: '/accessory/:id',
    Element: Detail,
    key: ACCESS.VIEW_ACCESSORY,
  },
]

export { accessoryRouter }
